module.exports = __webpack_public_path__ + "img/ic-help-toc-background.168329a4.svg";